import moment from "moment-timezone";
import React, { useContext, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import PageItemContext from "../../context/PageItemContext/PageItmContext";

import { DatePicker } from "antd";
import { MOMENT_SETTING } from "../../constant";
import ChartReusable from "../../chartReuseble/ChartReusable";
const { RangePicker } = DatePicker;

const PageItemViewPopup = (props) => {
  const { pageId, handlePreview, qpiId, setStartData, setEndData } = props;
  const {
    pageItemViewPop,
    setPageItemViewPop,
    pageItemData,
    chartData,
    categories,
    setCategories,
    setChartData,
    chartTitle,
  } = useContext(PageItemContext);
  const [checkValue, setCheckValue] = useState("chart");

  const dateChange = (value) => {
    handlePreview(
      pageId,
      qpiId,
      value ? moment.utc(value[0].$d).format(MOMENT_SETTING.FORMATE) : null,
      value ? moment.utc(value[1].$d).format(MOMENT_SETTING.FORMATE) : null,
      null,
      chartTitle
    );
    setStartData(
      value ? moment.utc(value[0].$d).format(MOMENT_SETTING.FORMATE) : null
    );
    setEndData(
      value ? moment.utc(value[1].$d).format(MOMENT_SETTING.FORMATE) : null
    );
  };

  const handleGrid = (e) => {
    setCheckValue(e.target.value);
    setCategories([]);
    setChartData([]);
    handlePreview(pageId, qpiId, null, null, e.target.value, chartTitle);
  };
  const handleList = (e) => {
    setCheckValue(e.target.value);
    setCategories([]);
    setChartData([]);
    handlePreview(pageId, qpiId, null, null, e.target.value, chartTitle);
  };

  const closeModal = () => {
    setCategories([]);
    setChartData([]);
    setPageItemViewPop(!pageItemViewPop);
    localStorage.removeItem("title");
  };

  return (
    <Modal size="xl" isOpen={pageItemViewPop} toggle={() => closeModal()}>
      <ModalHeader toggle={() => closeModal()}>
        <span>{"Show Page Item View"}</span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md="6 mb-3">
            <RangePicker onChange={(value) => dateChange(value)} />
          </Col>
          <Col
            md="6 mb-3"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-evenly",
            }}
          >
            <div className="radio radio-primary">
              <input
                id="radio7"
                type="radio"
                value={"chart"}
                onChange={(e) => handleGrid(e)}
                checked={checkValue === "chart"}
              />
              <Label htmlFor="radio7">{"Chart View"}</Label>
            </div>
            <div className="radio radio-primary">
              <input
                id="radio8"
                type="radio"
                value={"list"}
                onChange={(e) => handleList(e)}
                checked={checkValue === "list"}
              />
              <Label htmlFor="radio8">{"List View"}</Label>
            </div>
          </Col>
        </Row>
        <Row>
          {checkValue === "chart" ? (
            <ChartReusable
              categories={categories}
              arr={pageItemData}
              chartData={chartData}
            />
          ) : checkValue === "list" ? (
            <Col sm="12">
              <Card>
                <CardBody style={{ padding: "0" }}>
                  <Card>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr>
                            <th scope="col">{"Details"}</th>
                            <th scope="col">{"Views"}</th>
                            <th scope="col">{"Date"}</th>
                          </tr>
                        </thead>
                        {pageItemData.map((elem) => (
                          <tbody>
                            <tr>
                              <th scope="row">{elem.pageDetails.pageTitle}</th>
                              <th scope="row">{elem.views}</th>
                              <td>
                                {elem.date &&
                                  moment(
                                    new Date(elem.date).toLocaleString(
                                      undefined,
                                      {
                                        timeZone:
                                          Intl.DateTimeFormat().resolvedOptions()
                                            .timeZone,
                                      }
                                    )
                                  ).format(MOMENT_SETTING.FORMATE)}
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </Table>
                    </div>
                  </Card>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default PageItemViewPopup;
